var exports = {
  "kL": "GuildEmojiTab.module__container___VGRQRG",
  "ne": "GuildEmojiTab.module__controls___VGRQRG",
  "Rt": "GuildEmojiTab.module__searchInput___VGRQRG",
  "dc": "GuildEmojiTab.module__spinnerContainer___VGRQRG",
  "lm": "GuildEmojiTab.module__notice___VGRQRG",
  "ut": "GuildEmojiTab.module__noticeText___VGRQRG",
  "gH": "GuildEmojiTab.module__emojiSection___VGRQRG",
  "z5": "GuildEmojiTab.module__emojiSections___VGRQRG",
  "vf": "GuildEmojiTab.module__emojiSectionsGrid___VGRQRG",
  "Kt": "GuildEmojiTab.module__emojiSectionTitle___VGRQRG",
  "NX": "GuildEmojiTab.module__emojiItemsList___VGRQRG",
  "fP": "GuildEmojiTab.module__emojiGrid___VGRQRG",
  "vC": "GuildEmojiTab.module__modalErrorContainer___VGRQRG",
  "Mm": "GuildEmojiTab.module__modalErrorIntro___VGRQRG",
  "pH": "GuildEmojiTab.module__modalErrorItem___VGRQRG",
  "MU": "GuildEmojiTab.module__modalErrorDetails___VGRQRG",
  "N3": "GuildEmojiTab.module__modalErrorName___VGRQRG",
  "lR": "GuildEmojiTab.module__modalErrorMessage___VGRQRG",
};

module.exports = exports;
